import { HttpClient, HttpParams } from "@angular/common/http";

import { Injectable } from "@angular/core";
import { EndPoint } from "@endpoint";
import { LoginServices } from "@login";
import { BaseGetProvider } from "@tendercuts/http";
import { InventoryLog } from "@tendercuts/models";

@Injectable({
  providedIn: "root",
})
export class InventoryDebugService extends BaseGetProvider<InventoryLog> {
  constructor(
    public http: HttpClient,
    public endpointService: EndPoint,
    public loginService: LoginServices,
  ) {
    super(http);
    this.delegate = this;
  }

  preProcessResponse(response: any): Array<any> {
    return response.results;
  }

  get isAuthenticatedEndpoint(): boolean {
    return true;
  }

  get authProtocol(): LoginServices {
    return this.loginService;
  }

  get model(): typeof InventoryLog {
    return InventoryLog;
  }

  get endpoint(): string {
    return this.endpointService.fetchInventoryLog();
  }

  get isCachable(): boolean {
    return false;
  }

  getParams(storeId: number, sku: string, createdAt: string): HttpParams {
    let params: HttpParams = new HttpParams();
    params = params.append("store_id", storeId.toString());
    params = params.append("sku", sku);
    params = params.append("created_at", createdAt);

    return params;
  }
}
